<template>
	<!-- 客户发票管理 -->
	<div class="saleCustomerManagement sale-customer-invoice-page">
		<div class="public_Spacing customerManagementPC">
			<div class="pulbic_oparetionBlock sale-customer-filter-panel">
				<div class="sale-customer-filter-head">
					<div>
						<div class="sale-customer-filter-title">筛选条件</div>
						<div class="sale-customer-filter-subtitle">按客户名称和客户等级筛选开票额度数据</div>
					</div>
					<div class="sale-customer-filter-count">共 {{ count || 0 }} 条</div>
				</div>
				<div class="public_criteriaRange customerManagementPC-select sale-customer-filter-controls">


					<!-- <div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">时间：</label>
						<div class="el-select public_optionSty">
							<el-date-picker v-model="cusQueryTime" value-format="yyyy-MM-dd" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</div>
					</div> -->


					<div class="public_oparetionBlock_Menu sale-customer-filter-item">
						<label class="public_lbSty">客户名称：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<el-input maxlength="7" type="text" placeholder="请输入客户名称" v-model="cusQueryName"
									clearable></el-input>
							</div>
						</div>
					</div>
					<!-- <div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">手机号：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<el-input maxlength="11" type="text" placeholder="请输入手机号" v-model="cusQueryiphone"
									clearable></el-input>
							</div>
						</div>
					</div> -->
					<div class="public_oparetionBlock_Menu sale-customer-filter-item">
						<label class="public_lbSty">客户等级：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="khdj" placeholder="请选择" clearable>
							<el-option v-for="item in khdjOperation" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<!-- <div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户星级：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="khxj" placeholder="请选择">
							<el-option v-for="item in khxjOperation" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div> -->
					<el-button class="public_saleWater_chaxun sale-customer-query-btn" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
				</div>
				<div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
					<!-- <el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button> -->

					<!-- <el-button class="public_saleWater_quanping" type="primary" :disabled="quanpDisabled" @click="fullScreen">
						<i class="iconfont icon-tuichuquanping1"></i>全屏
					</el-button> -->
				</div>
			</div>

			<div class="statistic sale-customer-statistic">
				<div class="statistic-item">
					<i class="el-icon-search" style="color: #EEB68B;"></i>
					<span class="statistic-label" style="color: #EBAA7A;">总可开</span>
					<span class="statistic-value" style="color: #EBAA7A;">{{ zed / 10000 }}(万元)</span>
				</div>
				<div class="statistic-item">
					<i class="el-icon-tickets" style="color: #86D185"></i>
					<span class="statistic-label" style="color: #67C668;">总已开</span>
					<span class="statistic-value" style="color: #67C668;">{{ zyk / 10000 }}(万元)</span>
				</div>
			</div>

			<div class="billOperationRecord-table pulbic_table_container sale-customer-table-card">
				<div class="sale-customer-table-head">
					<div>
						<div class="sale-customer-table-title">客户开票额度</div>
					</div>
					<div class="sale-customer-table-tag">发票额度明细</div>
				</div>
				<el-table tooltip-effect="dark" :data="tableData" :span-method="objectSpanMethod"
					@sort-change="onSortChange" style="width: 100%;"
					:default-sort="{ prop: 'waterNum', order: 'descending' }" class="public_tableColumn sale-customer-main-table"
					:header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }">
					<el-table-column prop="khmc" label="客户名称"></el-table-column>
					<el-table-column prop="dj" label="客户等级"></el-table-column>
					<el-table-column prop="xsze" label="物料销售额"></el-table-column>
					<el-table-column prop="yf" label="运费金额"></el-table-column>
					<el-table-column prop="ze" label="总额度"></el-table-column>
					<el-table-column prop="detail.bl" label="开票服务费(%)">
						<template slot-scope="scope">
							<span v-if="scope.row.detail.bl != null && !isNaN(parseFloat(scope.row.detail.bl))">
								{{ (parseFloat(scope.row.detail.bl) * 100).toFixed(2) }}%
							</span>
							<span v-else>{{ scope.row.detail.bl || '-'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="detail.wk" label="可开额度"></el-table-column>
					<el-table-column prop="detail.yk" label="已开额度"></el-table-column>
					<el-table-column label="操作" fixed="right" width="200">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn">
								<el-button type="primary" class="public_icon_xiangqing public_icon_width"
									v-shiroHiden="solelist" id="修改" size="small" @click="kpjlialClick(scope.row)">开票记录
								</el-button>
								<el-button type="primary" class="public_icon_xiangqing public_icon_width"
									style="color:#EBAA7A!important;" v-shiroHiden="solelist" id="修改" size="small"
									@click="xquserClick(scope.row)">详情
								</el-button>
								<!-- <el-dropdown>
									<span class="el-dropdown-link public_icon_qiyong">
										发票<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_xiangqing public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="kpjlialClick(scope.row)">开票记录
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_hongchongred public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="cdjlialClick(scope.row)">冲抵记录
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_xiugai public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="cduserClick(scope.row)">新增冲抵信息
											</el-button>
										</el-dropdown-item>
										<el-dropdown-item>
											<el-button type="primary" class="public_icon_xiangqing public_icon_width"
												v-shiroHiden="solelist" id="修改" size="small"
												@click="xquserClick(scope.row)">详情
											</el-button>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown> -->

							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page">
					<span style="font-size: 14px;color:#606266;" v-if="flag == '1'">共{{ count }}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]"
						layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>

			<div class="public-dialog">
				<el-dialog title="新增开票信息" :visible.sync="cusUpdateShow" width="30%" @close="kpmsgClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cusUpdateObj.ORMTB410CA00" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cusUpdateObj.ORMTB410CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">可开票额度:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cusUpdateObj.zkk" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">开票额度类型:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<template>
									<el-select v-model="kpedlxValue" placeholder="请选择">
										<el-option v-for="item in kpedlx" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</template>
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="">
							<el-upload :class="{ disabled: uploadDisabled }" ref="upload" :auto-upload="false" action=""
								:on-success="handleUploadSuccess" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :on-change="handleChange" :on-exceed="handleExceed"
								:file-list="fileList" :accept="acceptFormat" :limit="limitNum" :multiple="false" drag>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
								<div class="el-upload__tip" slot="tip" style="font-size:20px; color: red;">
									只能上传{{ acceptFormat }}格式的文件，每次上传的文件数量不能超过{{ limitNum }}个</div>
							</el-upload>

						</div>

						<div class="customerManagementPC-add-customer" style="padding-top: 40px;"
							v-if="fpdialogImageUrl">
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">名称:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="fpsbpdfmsgobj.xftt" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">税号:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="fpsbpdfmsgobj.xfsh" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">账号:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="cusUpdateObj.SETTB410CA05" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>
							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">开票金额:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<input type="text" v-model="fpsbpdfmsgobj.kpje" />
								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>

							<div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">时间:</div>
								<div class="customerManagementPC-add-customer-li-ipt">

									<el-date-picker v-model="cusUpdateObj.SETTB410CA07" value-format="yyyy-MM-dd">
										type="date"
										placeholder="选择日期">
									</el-date-picker>

								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div>


							<!-- <div class="customerManagementPC-add-customer-li">
								<div class="customerManagementPC-add-customer-li-name">是否冲抵:</div>
								<div class="customerManagementPC-add-customer-li-ipt">
									<template>
										<el-radio v-model="cusUpdateObj.SETTB411CA03" label="0">不冲抵</el-radio>
										<el-radio v-model="cusUpdateObj.SETTB411CA03" label="1">冲抵</el-radio>
									</template>

								</div>
								<div class="customerManagementPC-add-customer-li-type">*必填*</div>
							</div> -->
						</div>

						<div class="customerManagementPC-add-customer-btn">
							<el-button type="info" @click="cusUpdateShow = false">取消</el-button>
							<el-button type="primary" @click="cusUpdateServe">保存</el-button>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">
				<el-dialog title="新增冲抵信息" :visible.sync="cdsUpdateShow" width="70%" @close="cdCusClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cdsUpdateObj.SETTB411CA01" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="cdsUpdateObj.SETTB411CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cdsUpdateObj.SETTB411CA04" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>


						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="cdsUpdateObj.SETTB411CA05" value-format="yyyy-MM-dd">
									type="date"
									placeholder="选择日期">
								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<!-- <div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">冲抵:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cdsUpdateObj.SETTB411CA03" maxlength="100" />

								<template>
									<el-radio v-model="cdsUpdateObj.SETTB411CA03" label="0">不冲抵</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA03" label="1">冲抵</el-radio>

								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div> -->
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">冲抵类型:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<!--<input type="text" v-model="cdsUpdateObj.SETTB411CA03" maxlength="100" />-->

								<template>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="1">服务费8.5额度</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="2">服务费8.8额度</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="4">服务费9.1额度</el-radio>
									<el-radio v-model="cdsUpdateObj.SETTB411CA08" label="3">免服务费</el-radio>

								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="info" @click="cdsUpdateShow = false">取消</el-button>
							<el-button type="primary" @click="cdsUpdateServe">保存</el-button>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">

				<el-dialog title="发票审核" :visible.sync="salefpshWaterDetails" width="80%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="userfptj">
							<el-row :gutter="24">
								<el-col :span="6">
									<div class="">
										<span>
											免服务费可开额度
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.kkpmf }}</span>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="">
										<span>
											可开总额
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.zxf }}</span>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="">
										<span>
											8.5可开额度
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.kkpn }}</span>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="">
										<span>
											8.8可开额度
										</span>
									</div>
									<div class="">
										<span>{{ cusUpdateObj.kkpw }}</span>
									</div>
								</el-col>

							</el-row>
						</div>
						<!-- <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div> -->
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="fpshtableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB410CA07" label="申请时间">
								</el-table-column>
								<el-table-column prop="SETTB410CA01" label="申请人">
								</el-table-column>
								<el-table-column prop="SETTB410CA08" label="申请类型">
									<template slot-scope="scope">
										<p v-if="scope.row.SETTB410CA08 == '1'">
											<span>8.5</span>
										</p>
										<p v-if="scope.row.SETTB410CA08 == '2'">
											<span>8.8</span>
										</p>
										<p v-if="scope.row.SETTB410CA08 == '3'">

											<span>免服务费</span>

										</p>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB410CA18" label="申请金额">
								</el-table-column>
								<el-table-column prop="SETTB410CA21" label="服务费金额">
								</el-table-column>

								<el-table-column prop="SETTB410CA03" label="名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA04" label="税号">
								</el-table-column>
								<el-table-column prop="SETTB410CA16" label="单位地址">
								</el-table-column>
								<el-table-column prop="SETTB410CA02" label="电话">
								</el-table-column>
								<el-table-column prop="SETTB410CA15" label="开户银行">
								</el-table-column>
								<el-table-column prop="SETTB410CA05" label="银行账户">
								</el-table-column>
								<el-table-column prop="SETTB410CA22" label="是否退款">
									<template slot-scope="scope">
										<p class="public_icon_xiugai" v-if="scope.row.SETTB410CA22 == '1'">
											<span>是</span>
										</p>
										<p class="public_icon_dayin" v-else>
											<span>否</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB410CA09" label="状态">
									<template slot-scope="scope">
										<p class="public_icon_xiugai" v-if="scope.row.SETTB410CA09 == '0'">
											<span>待审核</span>
										</p>
										<p class="public_icon_dayin" v-if="scope.row.SETTB410CA09 == '1'">
											<span>已开票</span>
										</p>
										<p class="public_icon_zuofei" v-if="scope.row.SETTB410CA09 == '2'">
											<span>拒绝</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button
												v-if="scope.row.SETTB410CA09 == '0' || scope.row.SETTB410CA09 == '2'"
												class="public_icon_dayin public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargefpshbut(scope.row)">上传发票
											</el-button>
											<el-button v-if="scope.row.SETTB410CA09 == '0'"
												class="public_icon_zuofei public_icon_width public_icon_margin"
												type="error" size="small" @click="rechargefpjsbut(scope.row)">拒绝
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="fpshhandleSizeChange" @current-change="fpshhandleCurrentChange"
								:current-page.sync="fpshcurrentPage" :page-sizes="[10, 20, 30, 40]"
								:page-size="fpshdetailsPageLimit" layout="total,sizes, prev, pager, next, jumper"
								:total="fpshdetailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">

				<el-dialog title="审核拒绝" :visible.sync="salefpshjjDetails" width="80%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="fpshtableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB410CA07" label="申请时间">
								</el-table-column>
								<el-table-column prop="SETTB410CA01" label="申请人">
								</el-table-column>
								<el-table-column prop="SETTB410CA08" label="申请类型">
									<template slot-scope="scope">
										<p v-if="scope.row.SETTB410CA08 == '1'">
											<span>8.5</span>
										</p>
										<p v-if="scope.row.SETTB410CA08 == '2'">
											<span>8.8</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB410CA18" label="申请金额">
								</el-table-column>

								<el-table-column prop="SETTB410CA03" label="名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA04" label="税号">
								</el-table-column>
								<el-table-column prop="SETTB410CA16" label="单位地址">
								</el-table-column>
								<el-table-column prop="SETTB410CA02" label="电话">
								</el-table-column>
								<el-table-column prop="SETTB410CA15" label="开户银行">
								</el-table-column>
								<el-table-column prop="SETTB410CA05" label="银行账户">
								</el-table-column>
								<el-table-column prop="SETTB410CA09" label="状态">
									<template slot-scope="scope">
										<p class="public_icon_xiugai" v-if="scope.row.SETTB410CA09 == '0'">
											<span>待审核</span>
										</p>
										<p class="public_icon_dayin" v-if="scope.row.SETTB410CA09 == '1'">
											<span>已开票</span>
										</p>
										<p class="public_icon_zuofei" v-if="scope.row.SETTB410CA09 == '2'">
											<span>拒绝</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button
												v-if="scope.row.SETTB410CA09 == '0' || scope.row.SETTB410CA09 == '2'"
												class="public_icon_dayin public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargefpshbut(scope.row)">上传发票
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="fpshjjhandleSizeChange"
								@current-change="fpshjjhandleCurrentChange" :current-page.sync="fpshjjcurrentPage"
								:page-sizes="[10, 20, 30, 40]" :page-size="fpshjjdetailsPageLimit"
								layout="total,sizes, prev, pager, next, jumper" :total="fpshjjdetailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">

				<el-dialog title="详情" :visible.sync="salefpxqWaterDetails" width="90%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="userfptj">
							<el-row :gutter="24">
								<el-col :span="8">
									<div class="">
										<span>
											总额
										</span>
									</div>
									<div class="">
										<span>{{ userfpyd.ze }}</span>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="">
										<span>
											已开
										</span>
									</div>
									<div class="">
										<span>{{ userfpyd.yk }}</span>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="">
										<span>
											未开
										</span>
									</div>
									<div class="">
										<span>{{ userfpyd.wk }}</span>
									</div>
								</el-col>
							</el-row>
						</div>
						<!-- <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div> -->
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="userfpydData" style="width: 100%"
								class="public_tableColumn tableColumn_detail" :span-method="objectSpanMethodDetail"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="month" label="月份">
								</el-table-column>
								<el-table-column prop="xsze" label="总额">
								</el-table-column>
								<el-table-column prop="wl" label="物料">
								</el-table-column>
								<el-table-column prop="yf" label="运费">
								</el-table-column>
								<el-table-column prop="detail.bl" label="额度(%)">
									<template slot-scope="scope">
										<el-popover
											v-if="scope.row.detail.settb425VoList && scope.row.detail.settb425VoList.length"
											placement="right"
											width="260"
											trigger="hover">
											<el-table :data="scope.row.detail.settb425VoList" size="mini" border>
												<el-table-column prop="company" label="业务公司" align="center"></el-table-column>
												<el-table-column prop="wk" label="可开额度" align="center"></el-table-column>
											</el-table>
											<span slot="reference" class="invoice-quota-trigger">
												{{ (scope.row.detail.bl * 100).toFixed(2) }}%
											</span>
										</el-popover>
										<span v-else>{{ (scope.row.detail.bl * 100).toFixed(2) }}%</span>
									</template>
								</el-table-column>
								<el-table-column prop="detail.wk" label="可开">
								</el-table-column>
								<el-table-column prop="detail.yk" label="已开">
								</el-table-column>
								<el-table-column prop="detail.ze" label="总额">
								</el-table-column>
							</el-table>
						</div>
						<!-- <div class="billOperationRecord-page">
							<el-pagination @size-change="fpshhandleSizeChange" @current-change="fpshhandleCurrentChange"
								:current-page.sync="fpshcurrentPage" :page-sizes="[10, 20, 30, 40]"
								:page-size="fpshdetailsPageLimit" layout="total,sizes, prev, pager, next, jumper"
								:total="fpshdetailsCount">
							</el-pagination>
						</div> -->
					</div>
				</el-dialog>
			</div>



			<div class="public-dialog">
				<el-dialog title="开票记录" :visible.sync="saleWaterDetails" width="60%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<!-- <div class="salesWatersStatisticsPC-saleWaterDetails-btn public_operatBtn"
							style="margin-left:0;">
							<button class="public_saleWater_xinzeng pulic_cursor" @click="rechargeTypeAdd"><i
									class="iconfont icon-tianjia1"></i>新增</button>
						</div> -->
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="tableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB410CA01" label="客户名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA02" label="手机号">
								</el-table-column>
								<el-table-column prop="SETTB410CA06" label="开票金额">
								</el-table-column>
								<el-table-column prop="SETTB410CA03" label="名称">
								</el-table-column>
								<el-table-column prop="SETTB410CA04" label="税号">
								</el-table-column>
								<el-table-column prop="SETTB410CA05" label="账号">
								</el-table-column>
								<el-table-column prop="SETTB410CA07" label="开票时间">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargeTypeModify(scope.row)">修改
											</el-button>
										</div>
										<div class="CustomertopUpDig-content-table-btn">
											<el-button
												class="public_icon_xiangqing public_icon_width public_icon_margin"
												type="primary" size="small" @click="ckfp(scope.row.SETTB410CA12)">查看发票
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
								:current-page.sync="currentPage1" :page-sizes="[10, 20, 30, 40]"
								:page-size="detailsPageLimit" layout="total,sizes, prev, pager, next, jumper"
								:total="detailsCount">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">
				<el-dialog title="冲抵记录" :visible.sync="cdleWaterDetails" width="60%" @close="saleWaterDetailsclose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="salesWatersStatisticsPC-saleWaterDetails">
						<div class="salesWatersStatisticsPC-saleWaterDetails-table pulbic_table_container">
							<el-table :data="cdtableDataDetails" style="width: 100%" stripe class="public_tableColumn"
								:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
								<el-table-column prop="SETTB411CA01" label="客户名称">
								</el-table-column>
								<el-table-column prop="SETTB411CA02" label="手机号">
								</el-table-column>
								<el-table-column label="是否冲抵">
									<template slot-scope="scope">{{ scope.row.SETTB411CA03 == '0' ? '不冲抵' : '冲抵'
									}}</template>
								</el-table-column>
								<el-table-column prop="SETTB411CA04" label="金额">
								</el-table-column>
								<el-table-column prop="SETTB411CA08" label="冲抵类型">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">

											<span v-if="scope.row.SETTB411CA08 == '1'">服务费8.5额度</span>
											<span v-if="scope.row.SETTB411CA08 == '2'">服务费8.8额度</span>
											<span v-if="scope.row.SETTB411CA08 == '3'">免服务费</span>

										</div>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB411CA05" label="时间">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="CustomertopUpDig-content-table-btn">
											<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
												type="primary" size="small" @click="rechargeCdModify(scope.row)">修改
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="billOperationRecord-page">
							<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
								:current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 40]"
								:page-size="detailsPageLimit2" layout="total,sizes, prev, pager, next, jumper"
								:total="detailsCount2">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>


			<div class="public-dialog">
				<el-dialog title="新增" :visible.sync="customerManagementAdd" width="30%"
					@close="customerManagementAddName = ''" :closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">等级名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="customerManagementAddName" type="text" maxlength="40">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="warning" @click="customerManagementAdd = false">取消</el-button>
							<el-button type="primary" @click="customerManagementAddServe">保存</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 客户等级修改 -->
			<div class="public-dialog">
				<el-dialog title="修改开票信息" :visible.sync="customerManagementUpdate" width="30%"
					@close="customerManagemenUPObj = ''" :closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">等级名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="customerManagemenUPObj.SETTB206CA01" type="text">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="warning" @click="customerManagementUpdate = false">取消</el-button>
							<el-button type="primary" @click="customerManagementUpdateServe">保存</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 充值类型新增 rechargeTypeModifyDig-->
			<div class="public-dialog">
				<el-dialog title="新增" :visible.sync="rechargeTypeDig" width="30%" @close="rechargeTypeName = ''"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">充值类型名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="rechargeTypeName" type="text" maxlength="40">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="warning" @click="rechargeTypeDig = false">取消</el-button>
							<el-button type="primary" @click="rechaTypePreser">保存</el-button>
						</div>
					</div>
				</el-dialog>
			</div>

			<!-- 上传发票 -->
			<div class="public-dialog">
				<el-dialog title="上传发票" :visible.sync="rechargefpsh" width="50%" @close="kpmsgClose"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">

					<div class="">
						<el-upload :class="{ disabled: uploadDisabled }" ref="upload" :auto-upload="false" action=""
							:on-success="handleUploadSuccess" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :on-change="handleChange" :on-exceed="handleExceed"
							:file-list="fileList" :accept="acceptFormat" :limit="limitNum" :multiple="false" drag>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
							<div class="el-upload__tip" slot="tip" style="font-size:20px; color: red;">
								只能上传{{ acceptFormat }}格式的文件，每次上传的文件数量不能超过{{ limitNum }}个</div>
						</el-upload>

					</div>

					<div v-if="fpdialogImageUrl" class="customerManagementPC-add-customer" style="padding-top: 40px;">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="fpsbpdfmsgobj.xftt" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">税号:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="fpsbpdfmsgobj.xfsh" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">开票金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="number" v-model="fpsbpdfmsgobj.kpje" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="fpsbpdfmsgobj.kprq" type="date" placeholder="选择日期"
									value-format="yyyy-MM-dd">


								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-btn">
							<el-button type="info" @click="rechargefpsh = false">取消</el-button>
							<el-button type="primary" @click="rechaTypefpkptj">开票</el-button>
						</div>
					</div>

				</el-dialog>
			</div>

			<!-- 开票记录修改 -->
			<div class="public-dialog">
				<el-dialog title="修改开票记录" :visible.sync="rechargeTypeModifyDig" width="30%"
					@close="rechargeTypeModifyClose" :closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<!-- <div class="CustomerfillingDig-tab">
						<div class="rechargeType-tab-li">
							<div class="rechargeType-tab-li-text">充值类型名称：</div>
							<div class="rechargeType-tab-li-ipt">
								<input v-model="rechargeTypeUpOBJ.SETTB206CA01" type="text">
							</div>
							<div class="rechargeType-tab-li-b">*必填*</div>
						</div>
						<div class="CustomerfillingDig-tab-btn rechargeType-tab-btn">
							<el-button type="primary" @click="rechaTypePreserModify">保存</el-button>
							<el-button type="warning" @click="rechargeTypeModifyDig=false">取消</el-button>
						</div>
					</div> -->

					<div class="customerManagementPC-add-customer">
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeTypeUpOBJ.SETTB410CA01" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeTypeUpOBJ.SETTB410CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">抬头:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA03" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">税号:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA04" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">账号:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA05" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeTypeUpOBJ.SETTB410CA06" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="rechargeTypeUpOBJ.SETTB410CA07" value-format="yyyy-MM-dd">
									type="date"
									placeholder="选择日期">
								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-btn">
							<el-button type="info" @click="rechargeTypeModifyDig = false">取消</el-button>
							<el-button type="primary" @click="rechaTypePreserModify">保存</el-button>
						</div>
					</div>

				</el-dialog>
			</div>


			<div class="public-dialog">
				<el-dialog title="修改冲抵记录" :visible.sync="rechargeCdModifyDig" width="70%"
					@close="rechargeTypeModifyClose" :closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="customerManagementPC-add-customer">

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">客户名称:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeCdUpOBJ.SETTB411CA01" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">联系电话:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" disabled v-model="rechargeCdUpOBJ.SETTB411CA02" maxlength="11" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">金额:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="rechargeCdUpOBJ.SETTB411CA04" maxlength="100" />
							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">时间:</div>
							<div class="customerManagementPC-add-customer-li-ipt">

								<el-date-picker v-model="rechargeCdUpOBJ.SETTB411CA05" value-format="yyyy-MM-dd">
									type="date"
									placeholder="选择日期">
								</el-date-picker>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>

						<!-- 	<div class="customerManagementPC-add-customer-li">
							<div class="customerManagementPC-add-customer-li-name">是否冲抵:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<input type="text" v-model="cdsUpdateObj.SETTB411CA03" maxlength="100" />

								<template>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA03" label="0">不冲抵</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA03" label="1">冲抵</el-radio>
								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div> -->
						<div class="customerManagementPC-add-customer-li" v-if="rechargeCdUpOBJ.SETTB411CA03 == '1'">
							<div class="customerManagementPC-add-customer-li-name">冲抵类型:</div>
							<div class="customerManagementPC-add-customer-li-ipt">
								<template>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="1">服务费8.5额度</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="2">服务费8.8额度</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="4">服务费9.1额度</el-radio>
									<el-radio v-model="rechargeCdUpOBJ.SETTB411CA08" label="3">免服务费</el-radio>
								</template>

							</div>
							<div class="customerManagementPC-add-customer-li-type">*必填*</div>
						</div>
						<div class="customerManagementPC-add-customer-btn">
							<el-button type="info" @click="rechargeCdModifyDig = false">取消</el-button>
							<el-button type="primary" @click="rechCdPreserModify">保存</el-button>
						</div>
					</div>

				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="变动记录" :visible.sync="deductionRecord" width="70%"
					@close="ORMTB411ID = '', deductionRecordPage = 1, deductionRecordLimit = 10, deductionRecordCount = 0"
					:closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<el-table :data="deductionRecordtable" style="width: 100%" stripe class="public_tableColumn sale-customer-main-table"
						:header-cell-style="{ 'font-family': 'Microsoft YaHei', 'font-weight': 'bold', color: 'rgba(51,51,51,1)' }">
						<el-table-column prop="ORMTB413CA01" label="扣费时间">
						</el-table-column>
						<el-table-column prop="ORMTB440CA00" label="派单号">
						</el-table-column>
						<el-table-column prop="ORMTB413CA00" label="扣款金额">
						</el-table-column>
						<el-table-column prop="ORMTB413CA02" label="变动类型">
						</el-table-column>
						<!-- <el-table-column prop="" label="扣后金额">
						</el-table-column> -->
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<el-button v-if="scope.row.ORMTB413CA02 != '红冲'"
									class="public_icon_chongzhi public_icon_width public_icon_margin" type="primary"
									size="small" @click="DetailsWaterClick(scope.row)" id="详情">详情</el-button>
							</template>

						</el-table-column>
					</el-table>
					<div class="billOperationRecord-page">
						<el-pagination @size-change="deductionRecordSizeChange"
							@current-change="deductionRecordCurrentChange" :current-page.sync="deductionRecordPage"
							:page-sizes="[10, 20, 30, 40]" :page-size="deductionRecordLimit"
							layout="total,sizes, prev, pager, next, jumper" :total="deductionRecordCount">
						</el-pagination>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="详情" :visible.sync="DetailsWater" width="30%" :closeOnClickModal='false' append-to-body custom-class="sales-sale-customer-invoice-dialog">
					<div class="DetailsWater-Dialog">
						<div class="DWD-li">
							<div class="DWD-li-title">流水号</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA00 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">企业名称</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA05 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">客户名称</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA03 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">车牌号</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA01 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">派单时间</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CA19 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">结算时间</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CC00 || '' }}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">回执时间</div>
							<div class="DWD-li-text">{{ deductionRecordObj.ORMTB440CE00 || '' }}</div>
						</div>
						<div class="DWD-table">
							<div class="DWD-table-left-title">
								<div></div>
								<div>派单</div>
								<div>结算</div>
								<div>回执</div>
							</div>
							<div class="DWD-table-left-flex">
								<div>物料</div>
								<div>{{ deductionRecordObj.ORMTB440CA07 || '' }}</div>
								<div>{{ deductionRecordObj.ORMTB440CC02 || '' }}</div>
								<div></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>重量</div>
								<div>{{ deductionRecordObj.ORMTB440CA10 || 0 }}</div>
								<div>{{ deductionRecordObj.ORMTB440CC04 || 0 }}</div>
								<div v-if="deductionRecordObj.ORMTB440CF01 == '5'">{{ deductionRecordObj.ORMTB440CE09 ||
									0 }}
								</div>
								<div v-else></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>物料金额</div>
								<div>{{ deductionRecordObj.ORMTB440CA11 || 0 }}</div>
								<div>{{ deductionRecordObj.ORMTB440CC06 || 0 }}</div>
								<div></div>
							</div>
							<div class="DWD-table-left-flex">
								<div>运费金额</div>
								<div>{{ deductionRecordObj.ORMTB440CA12 || 0 }}</div>
								<div>{{ deductionRecordObj.jsORMTB440CA12 || 0 }}</div>
								<div v-if="deductionRecordObj.ORMTB440CF01 == '5'">{{ deductionRecordObj.ORMTB440CE10 ||
									0 }}
								</div>
								<div v-else></div>
							</div>
						</div>
					</div>
					<div class="DetailsWater-img">
						<div class="DetailsWater-img-text">回执记录</div>
						<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl"
							:preview-src-list="DetailsWatersrcList">
						</el-image>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import {
	Decimal
} from 'decimal.js';
export default {
	data() {
		return {
			customerManagementList: '',
			customerManagementValue: '',
			customerManagement: false,
			customerManagementAdd: false,
			customerManagementAddName: '',
			customerManagemenUPObj: '',
			customerManagementUpdate: false,
			cusQueryName: '',
			cusQueryTime: this.getCurrentMonthFirstDay(),
			cusQueryiphone: '',
			options: [],
			cusStatus: '',
			cusStatusList: [],
			tableData: [],
			flag: '',
			page: 1,
			pagesize: 10,
			currentPage: 1,
			count: 0,
			currentPage1: 1,
			detailsPageLimit: 10,
			detailsCount: 1,
			currentPage2: 1,
			detailsPageLimit2: 10,
			detailsCount2: 1,
			RechargetypeValue: '银行卡',
			RechargetypeOptions: [],
			CZRecordsDetails: [],
			CZRecordsPage: 1,
			CZRecordsPageLimit: 10,
			CZRecordsCount: 0,
			tableDataDetails: [],
			cdtableDataDetails: [],
			offerDetailsTab: [],
			ORMTB411ID: '',
			CustomerfillingDig: false,
			wayTypeValue: '',
			wayTypeOptions: [{
				value: 'CW',
				label: '财务'
			},
			{
				value: 'XX',
				label: '线下'
			},
			{
				value: 'XS',
				label: '线上'
			},
			],
			khdj: '',
			khdjOperation: [{
				value: '',
				label: '全部',
			}, {
				value: '0301',
				label: '一级客户',
			}, {
				value: '0302',
				label: '二级客户',
			}, {
				value: '0303',
				label: '三级客户',
			}, {
				value: '0304',
				label: '四级客户',
			}, {
				value: '0305',
				label: '五级客户',
			}, {
				value: '0306',
				label: '六级客户',
			}, {
				value: '0307',
				label: '七级客户',
			}, {
				value: '0308',
				label: '八级客户',
			},
			{
				value: '0309',
				label: '九级客户',
			}
			],
			khxj: '',
			khxjOperation: [{
				value: '',
				label: '全部',
			}, {
				value: '1',
				label: 'V1',
			}, {
				value: '2',
				label: 'V2',
			}, {
				value: '3',
				label: 'V3',
			}, {
				value: '4',
				label: 'V4',
			}, {
				value: '5',
				label: 'V5',
			}],
			kpedlx: [{
				value: '1',
				label: '服务费8.5额度'
			}, {
				value: '2',
				label: '服务费8.8额度'
			}, {
				value: '3',
				label: '额度免费'
			}],
			kpedlxValue: '1',
			CZmoney: '',
			Czmaxlength: 10, //充值限额
			CZremark: '',
			HCmoney: '',
			HCremark: '',
			HCamountCapitalText: '',
			amountCapitalText: '',
			cusInsertShow: false,
			cusInsertObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			cusUpdateShow: false,
			cusUpdateObj: {
				ORMTB410ID: '',
				ORMTB410CA00: '',
				SETTB410CA01: '',
				ORMTB410CA02: '',
				SETTB410CA03: '',
				SETTB410CA04: '',
				SETTB410CA05: '',
				SETTB410CA06: '',
				SETTB410CA07: '',
				SETTB411CA03: '1'


			},
			cdsUpdateShow: false,
			cdsUpdateObj: {
				ORMTB410ID: '',
				SETTB411CA00: '',
				SETTB411CA01: '',
				SETTB411CA02: '',
				SETTB411CA03: '1',
				SETTB411CA04: '',
				SETTB411CA05: ''
			},
			cusDJSetObj: {},
			freezeInsertShow: false,
			saleWaterDetails: false,

			cdleWaterDetails: false,
			rechargeTypeDig: false,
			rechargeTypeName: '',
			rechargeTypeUpOBJ: {
				SETTB206CA01: ''
			},
			rechargeTypeModifyDig: false,
			rechargeCdModifyDig: false,
			rechargeCdUpOBJ: {
				SETTB206CA01: '',
				SETTB411CA08: ''
			},
			czRechargetypeShow: false,
			HCshow: false,
			HCObj: '',
			preferentialRecord: false,
			offerDetails: false,
			DetailsWater: false,
			deductionRecord: false,
			deductionRecordObj: '',
			deductionRecordtable: [],
			deductionRecordPage: 1,
			deductionRecordLimit: 10,
			deductionRecordCount: 0,
			DetailsWaterurl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
			DetailsWatersrcList: [
				'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
				'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
			],
			preferentialType: 0,
			solelist: [],
			cusUDJSetpdateShow: false,
			tableDataGradePre: [],
			innerVisible: false,
			// 发票审核START
			fpshcurrentPage: 1,
			fpshdetailsPageLimit: 10,
			fpshdetailsCount: 1,

			fpshjjcurrentPage: 1,
			fpshjjdetailsPageLimit: 10,
			fpshjjdetailsCount: 1,

			salefpshWaterDetails: false,
			salefpshjjDetails: false,
			salefpxqWaterDetails: false,
			rechargefpsh: false,
			fpshtableDataDetails: [],
			userfpyd: {},
			// 发票审核END

			//发票上传START
			uploadUrl: '/api/upload', // 文件上传地址
			fileList: [], // 已上传的文件列表
			acceptFormat: '.pdf', // 支持上传的文件格式
			limitNum: 1, // 限制每次上传的文件数量
			maxSize: 20, // 限制文件的最大大小（MB）
			fpdialogImageUrl: '', //票据URL
			downloadUrl: '/api/download', // 文件下载地址
			fpsqobj: {},
			fpsbpdfmsgobj: {

			},
			addimg: [],
			formdata: new FormData(),
			//发票上传END
			zyk: '',
			zed: '',
			userfpydData: []
		};
	},
	created() {
		var list = "";
		if (this.$route.query.mark != "" && this.$route.query.mark != null) {
			this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
			list = JSON.parse(sessionStorage.getItem("qpSolelist"));
			sessionStorage.removeItem('qpUobj');
			sessionStorage.removeItem('qpSolelist');
			this.quanpDisabled = true;
		} else {
			this.userobj = this.$store.state.uobj;
			list = this.$store.state.solelist;
			this.quanpDisabled = false;
		}
		var path = this.$route.path;
		if (path === "/saleCustomerInvoice") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		console.log(this.solelist);


		// console.log(this.solelist)
		// 赋值，缓存销毁
		// this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		// sessionStorage.removeItem(this.currentUrl);
		let queryObj = JSON.parse(sessionStorage.getItem('queryObj'));
		if (queryObj) {
			this.init(queryObj);
		}
		// console.log(this.solelist)
		this.wayTypeValue = this.wayTypeOptions[0].value
	},
	computed: {
		// 计算属性返回当月的一号日期
		uploadDisabled: function () {
			// console.log(this.ruleForm.csAvatar)
			return this.fpdialogImageUrl != '';
		},
	},
	watch: {
		cusQueryName: function (newVal, oldVal) {
			if (!newVal) {
				const obj = {
					cusQueryName: '',
					cusQueryiphone: this.cusQueryiphone,
					cusStatus: this.cusStatus,
					currentPage: this.currentPage,
					page: this.page,
					pagesize: this.pagesize,
					khdj: this.khdj,
				};
				sessionStorage.removeItem('queryObj');
				sessionStorage.setItem('queryObj', JSON.stringify(obj));
			}
		},
		cusQueryiphone: function (newVal, oldVal) {
			if (!newVal) {
				const obj = {
					cusQueryName: this.cusQueryName,
					cusQueryiphone: '',
					cusStatus: this.cusStatus,
					currentPage: this.currentPage,
					page: this.page,
					pagesize: this.pagesize,
					khdj: this.khdj,
				};
				sessionStorage.removeItem('queryObj');
				sessionStorage.setItem('queryObj', JSON.stringify(obj));
			}
		},
		khdj: function (newVal, oldVal) {
			if (!newVal) {
				const obj = {
					cusQueryName: this.cusQueryName,
					cusQueryiphone: this.cusQueryiphone,
					cusStatus: this.cusStatus,
					currentPage: this.currentPage,
					page: this.page,
					pagesize: this.pagesize,
					khdj: '',
				};
				sessionStorage.removeItem('queryObj');
				sessionStorage.setItem('queryObj', JSON.stringify(obj));
			}
		},
	},
	mounted() {
		this.querycusList()
	},
	// 存储数据
	// beforeDestroy() {
	// 	var obj = {
	// 		cusQueryName: this.cusQueryName, //客户名称
	// 		// cusQueryTime: this.cusQueryTime, //客户名称
	// 		cusQueryiphone: this.cusQueryiphone, //客户名称
	// 		cusStatus: this.cusStatus, //客户状态
	// 		currentPage: this.currentPage, //当前页数
	// 		page: this.page, //页码
	// 		pagesize: this.pagesize, //每页条数,
	// 		khdj: this.khdj, //客户等级
	// 	};
	// 	sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
	// },
	beforeRouteLeave(to, from, next) {
		const obj = {
			cusQueryName: this.cusQueryName,
			cusQueryiphone: this.cusQueryiphone,
			cusStatus: this.cusStatus,
			currentPage: this.currentPage,
			page: this.page,
			pagesize: this.pagesize,
			khdj: this.khdj,
		};
		sessionStorage.setItem('queryObj', JSON.stringify(obj));
		next();
	},
	methods: {
		
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			// 只合并前5列
			if (columnIndex < 5) {
				// 数据检查
				if (!this.tableData || !this.tableData.length) {
					return { rowspan: 1, colspan: 1 };
				}

				// 获取当前行的 khId，处理 undefined 情况
				const currentKhId = row && row.khId !== undefined ? row.khId : '';

				// 判断是否需要开始新的合并
				let needSpan = false;

				if (rowIndex === 0) {
					// 第一行总是需要判断是否合并
					needSpan = true;
				} else {
					// 获取上一行
					const prevRow = this.tableData[rowIndex - 1];
					const prevKhId = prevRow && prevRow.khId !== undefined ? prevRow.khId : '';

					// 如果当前 khId 和上一行不同，需要开始新的合并
					needSpan = currentKhId !== prevKhId;
				}

				// 如果不需要合并或者当前行不存在
				if (!needSpan || !row) {
					// 如果当前行的 khId 和上一行相同，则被合并
					if (rowIndex > 0) {
						const prevRow = this.tableData[rowIndex - 1];
						const prevKhId = prevRow && prevRow.khId !== undefined ? prevRow.khId : '';
						if (currentKhId === prevKhId) {
							return { rowspan: 0, colspan: 0 };
						}
					}
					return { rowspan: 1, colspan: 1 };
				}

				// 需要合并，计算合并的行数
				let rowspan = 1;
				for (let i = rowIndex + 1; i < this.tableData.length; i++) {
					const nextRow = this.tableData[i];
					if (!nextRow) break;

					const nextKhId = nextRow.khId !== undefined ? nextRow.khId : '';
					if (nextKhId === currentKhId) {
						rowspan++;
					} else {
						break;
					}
				}

				return rowspan > 1 ? { rowspan: rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
			}

			return { rowspan: 1, colspan: 1 };
		},
		objectSpanMethodDetail({ row, column, rowIndex, columnIndex }) {
			// 只合并前4列：月份、总额、物料、运费
			if (columnIndex < 4) {
				// 防御性检查
				if (!this.userfpydData || !Array.isArray(this.userfpydData) || this.userfpydData.length === 0) {
					return { rowspan: 1, colspan: 1 };
				}

				if (!row) {
					return { rowspan: 1, colspan: 1 };
				}

				// 获取当前行的月份
				const currentMonth = row.month || '';

				// 处理第一行的情况
				if (rowIndex === 0) {
					let rowspan = 1;

					// 向后查找月份相同的行
					for (let i = rowIndex + 1; i < this.userfpydData.length; i++) {
						const nextRow = this.userfpydData[i];
						if (!nextRow) break;

						const nextMonth = nextRow.month || '';
						if (nextMonth === currentMonth) {
							rowspan++;
						} else {
							break;
						}
					}

					// 如果有多行相同的月份，则合并前4列
					return rowspan > 1 ? { rowspan: rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
				}

				// 处理非第一行的情况
				const prevRow = this.userfpydData[rowIndex - 1];
				if (!prevRow) {
					return { rowspan: 1, colspan: 1 };
				}

				const prevMonth = prevRow.month || '';

				// 如果当前行的月份与上一行相同，则合并
				if (currentMonth === prevMonth) {
					return { rowspan: 0, colspan: 0 };
				}

				// 如果不同，计算当前月份后面有多少相同的行
				let rowspan = 1;
				for (let i = rowIndex + 1; i < this.userfpydData.length; i++) {
					const nextRow = this.userfpydData[i];
					if (!nextRow) break;

					const nextMonth = nextRow.month || '';
					if (nextMonth === currentMonth) {
						rowspan++;
					} else {
						break;
					}
				}

				return rowspan > 1 ? { rowspan: rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
			}

			// 第5列及之后不合并
			return { rowspan: 1, colspan: 1 };
		},
		onSortChange({
			prop,
			order
		}) {
			// console.log(order)
			if (prop == 'ORMTB410CA06') {
				this.tableData.sort(this.compare(prop, order));
			}

		},

		//预览
		handlePictureCardPreview(file) {
			// this.dialogImageUrl = file.url;
			console.log(file)
			// this.dialogVisible = true;
		},
		handleChange(file, fileList) {

			console.log(fileList);
			this.addimg = fileList[0].raw;
			this.fileList = []
			const formData = new FormData();
			formData.append("file", this.addimg);
			// formData.append('ORMTB470CA00', this.ORMTB470CA00)
			let loading = this.$loading({
				lock: true,
				text: '上传中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var url = "/system/uploadBD";

			this.axios.post(url, formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					console.log(res)
					this.$message({
						message: res.data.data.message,
						type: 'success'
					});
					// this.fileList.push({
					// 	name: param.file.name,
					// 	url: res.data.data.bdurl,
					// 	uid: param.file.uid,
					// });
					this.fpdialogImageUrl = res.data.data.bdurl

					this.fileList = fileList


					this.hdPDFsb()

					// this.bdurlList.push(res.data.data.bdurl)
					// this.dialogVisible = true
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})

			//   console.log(file);
		},
		//控制上传数量提示
		handleExceed(files, fileList) {
			this.$message.warning(`最多上传1个文件`);
		},
		// 删除
		handleRemove(file, fileList) {
			console.log(file)

			console.log(fileList)

			return;

			var index1 = this.fpdialogImageUrl.lastIndexOf("2022", "2023")
			var imgdel = this.fpdialogImageUrl.substring(index1)
			// console.log(imgdel)
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var url = "/orm/ormtb440/deleteFile";
			var postData = {
				fileName: imgdel
			}
			this.axios.post(url, postData).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					// console.log(res)
					this.fpdialogImageUrl = '';
					this.fpsbpdfmsgobj = {}
					this.formdata = new FormData();
					this.$message({
						message: res.data.message,
						type: 'success'
					});
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})


		},
		hdPDFsb() {

			var url = "/set/settb410Entity/recog"
			var postData = {
				SETTB410CA12: this.fpdialogImageUrl
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					console.log(res)
					this.fpsbpdfmsgobj = res.data.data
					// this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})

		},

		// 文件上传成功后的回调函数
		handleUploadSuccess(response, file, fileList) {

		},


		getCurrentMonthFirstDay() {
			// const now = new Date();
			// const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

			// console.log(new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0])
			// return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];

			var date = new Date() // this.startTime = '2022-5-02'
			var new_year = date.getFullYear() // 取当前的年份
			var month = date.getMonth()
			var new_month = month + 1 // 取当前的月份
			if (month > 12) {
				new_month -= 12 // 月份减
				new_year++ // 年份增
			}
			var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天
			var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
			if (firstDay.getMonth() < 10) {
				var mon = "0" + firstDay.getMonth()
			} else {
				var mon = firstDay.getMonth()
			}
			var startDate = firstDay.getFullYear() + '-' + mon + '-' + "0" + firstDay.getDate();
			var endDate = firstDay.getFullYear() + '-' + mon + '-' + lastDay;
			return startDate
			// console.log(startDate)

			// 最后输出 2022-5-01  2022-5-31

		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName];
				var value2 = obj2[propertyName];
				// console.log(value2)

				if (typeof value1 === "string" && typeof value2 === "string") {
					const res = value1.localeCompare(value2);
					return sort === "ascending" ? res : -res;
				} else {
					// if (value1 <= value2) {
					// 	return sort === "ascending" ? -1 : 1;
					// } else if (value1 > value2) {
					// 	return sort === "ascending" ? 1 : -1;
					// }
				}
			};
		},


		// 账号的启用和禁用
		updateUserStatus(item) {
			var url = "/orm/ormtb410/updateUserStatus"
			var postData = {
				ORMTB410ID: item.ORMTB410ID,
				ORMTB410CA02: item.ORMTB410CA02, // 手机号
				ORMTB410CB00: item.ORMTB410CB00 == 1 ? '0' : '1', //状态 启用传1，禁用传0
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// 账号的启用和禁用
		updateYfStatus(item) {
			var url = "/orm/ormtb410/updateORMTB410CB10"
			var postData = {
				ORMTB410ID: item.ORMTB410ID,
				ORMTB410CB10: item.ORMTB410CB10 == 1 ? '0' : '1', //状态 启用传1，禁用传0
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// 下单的限制和解除限制
		updateUserLimitStatus(item) {
			var url = "/orm/ormtb410/updateORMTB410CB01"
			var postData = {
				ORMTB410ID: item.ORMTB410ID,
				// ORMTB410CA02: item.ORMTB410CA02, // 手机号
				ORMTB410CB01: item.ORMTB410CB01 == 1 ? '0' : '1', //状态 启用传1，禁用传0
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		//初始化数据
		init(data) {
			this.cusQueryName = data.cusQueryName;
			// this.cusQueryTime = this.historyInfo.cusQueryTime;
			this.cusQueryiphone = data.cusQueryiphone;
			this.currentPage = data.currentPage;
			this.page = data.page;
			this.pagesize = data.pagesize;
			this.cusStatus = data.cusStatus;
			this.khdj = data.khdj;
		},
		fullScreen() {
			//全屏
			var mark = 1;
			sessionStorage.setItem(
				"qpSolelist",
				JSON.stringify(this.$store.state.solelist)
			);
			sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

			let Logistics = this.$router.resolve({
				path: "/SalesCustomer",
				query: {
					mark: mark,
				},
			});
			this.$baseAPI.requestFullScreen(Logistics);
		},
		querycusList(dataFlag) {
			// if (!this.cusQueryTime) {
			// 	this.$message.error('请选择时间')
			// 	return;
			// }

			this.tableData = []
			// this.flag = dataFlag
			// this.count =0
			var url = "/set/settb425/selectPage"
			// if (dataFlag) {
			// 	this.page = ''
			// 	this.pagesize = ''
			// }
			var postData = {
				// ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
				ORMTB410CA00: this.cusQueryName, //客户名称
				// TIME: this.cusQueryTime, //时间
				// ORMTB410CA02: this.cusQueryiphone, //客户手机号
				ORMTB410CA06: this.khdj, //客户等级
				// flag: dataFlag, //查询所有客户全部展示
				pageNum: this.page,
				pageSize: this.pagesize
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.tableData = this.splitPageData(res.data.data.page);
					this.count = res.data.count;
					this.zed = res.data.data.zed
					this.zyk = res.data.data.zyk

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}

				setTimeout(() => {
					loading.close()
				}, 300)

			}).catch(() => {
				loading.close()
			})
		},
		splitPageData(pageData) {
			if (!Array.isArray(pageData)) {
				return pageData;
			}
			return pageData.flatMap(item => {
				const details = Array.isArray(item.detail) ? item.detail : [item.detail || {}];

				return details.map(detailItem => ({
					khId: item.khId || '',
					khmc: item.khmc || '',
					dj: item.dj || '',
					month: item.month,
					wl: item.wl || '',
					yf: item.yf || '',
					xsze: item.xsze || '',
					ze: item.ze || '',
					detail: detailItem
				}));
			});
		},
		freezeSetClick() {
			this.freezeInsertShow = true
			this.cusSelect()
		},
		cusSelect() {
			var url = "/orm/ormtb405/select"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataGradePre = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.querycusList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.querycusList();
		},

		fpshhandleSizeChange(val) { //发票审核-分页

			this.fpshdetailsPageLimit = val;
			this.fpshcurrentPage = 1;
			console.log(this.cusUpdateObj)

			this.queryfpsheQuery(0)

		},
		fpshhandleCurrentChange(val) { //发票审核-分页
			// this.fpshcurrentPage = 1;
			this.queryfpsheQuery(0)
		},

		fpshjjhandleSizeChange(val) { //发票审核拒绝-分页

			this.fpshjjdetailsPageLimit = val;
			this.fpshjjcurrentPage = 1;
			this.queryfpsheQuery(2)

		},
		fpshjjhandleCurrentChange(val) { //发票审核拒绝-分页
			// this.fpshjjcurrentPage = 1;
			this.queryfpsheQuery(2)
		},



		offerDetailsClick(row) {
			this.offerDetails = true
			this.offerDetailsTab = []
			var url = "/orm/ormtb412/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB411ID: row.ORMTB411ID,
				SETTB206CD01: this.userobj.pertb005.pertb005cd01,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.offerDetailsTab = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordClick(row) {
			// console.log(row)
			this.deductionRecordtable = []
			// this.deductionRecordCount=0
			var url = "/orm/ormtb413/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.ORMTB411ID = row.ORMTB411ID
			var postData = {
				ORMTB411ID: this.ORMTB411ID,
				page: this.deductionRecordPage,
				limit: this.deductionRecordLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordtable = res.data.data;
					this.deductionRecordCount = res.data.count
					this.deductionRecordtable.forEach(item => {
						if (item.ORMTB413CA02 == 'KK') {
							item.ORMTB413CA02Text = "扣款"
						} else if (item.ORMTB413CA02 == 'TK') {
							item.ORMTB413CA02Text = "退款"
						}
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordSizeChange(val) {
			this.deductionRecordLimit = val;
			this.deductionRecordPage = 1;
			this.deductionRecordClick();
		},
		deductionRecordCurrentChange(val) {
			this.deductionRecordPage = val;
			this.deductionRecordClick();
		},
		queryWayTypeQuery() {
			this.tableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb410/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID,
				page: this.currentPage1,
				limit: this.detailsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataDetails = res.data.data;
					this.detailsCount = res.data.count
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		queryfpsheQuery(data) { //发票审核
			this.fpshtableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb410Entity/settb410ListAdmin"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			let pag
			let limit
			if (this.salefpshWaterDetails) {
				pag = this.fpshcurrentPage;
				limit = this.fpshdetailsPageLimit
			}
			if (this.salefpshjjDetails) {
				pag = this.fpshjjcurrentPage;
				limit = this.fpshjjdetailsPageLimit
			}

			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID,
				SETTB410CA09: data,
				page: pag,
				limit: limit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				console.log(this.cusUpdateObj.ORMTB410ID)
				if (res.data.code == 200) {
					this.fpshtableDataDetails = res.data.data.list;
					this.fpshdetailsCount = res.data.data.total;
					this.fpshjjdetailsCount = res.data.data.total;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		queryCdWayTypeQuery() {
			this.cdtableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb411/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB411CA00: this.cdsUpdateObj.ORMTB410ID,
				page: this.currentPage2,
				limit: this.detailsPageLimit2
			}
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.cdtableDataDetails = res.data.data.data;
					console.log(res)
					this.detailsCount2 = res.data.data.count
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange1(val) {
			this.detailsPageLimit = val;
			this.currentPage1 = 1;
			// this.deductionRecordClick();
			this.queryWayTypeQuery()
		},
		handleCurrentChange1(val) {
			this.currentPage1 = val;
			// this.deductionRecordClick();
			this.queryWayTypeQuery()
		},
		handleSizeChange2(val) {
			this.detailsPageLimit2 = val;
			this.currentPage2 = 1;
			// this.deductionRecordClick();
			this.queryWayTypeQuery()
		},
		handleCurrentChange2(val) {
			this.currentPage2 = val;
			// this.deductionRecordClick();
			this.queryCdWayTypeQuery()
		},
		saleWaterDetailsclose() {

		},
		CustomerfillingDigClose() {

		},
		cusInsertClose() {
			this.cusInsertObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
		},
		cusInsertServe() {
			if (this.cusInsertObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
			var reQ = /^1[3-9][0-9]{9}$/;
			if (!reQ.test(this.cusInsertObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
			if (this.preferentialType == 1) {
				if (this.cusInsertObj.ORMTB410CA06.length == 0) {
					return this.$message.error('请选择客户等级')
				}
			}
			var url = "/orm/ormtb410/insertOrmtb410"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = this.cusInsertObj
			postData.ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.querycusList()
					this.cusInsertShow = false
					this.cusInsertObj = {
						ORMTB400ID: '',
						ORMTB410CA00: '',
						ORMTB410CA01: '',
						ORMTB410CA02: '',
						ORMTB410CA06: '',
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusDJSetInsertServe() {
			var url = "/orm/ormtb405/update"
			var settb400List = []

			this.tableDataGradePre.forEach((resitme) => {
				settb400List.push(resitme)

			})
			var postData = {
				list: settb400List,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.querycusList()
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.freezeInsertShow = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// upCusClose() {
		// 	this.cusUpdateObj = {
		// 		ORMTB400ID: '',
		// 		ORMTB410CA00: '',
		// 		ORMTB410CA01: '',
		// 		ORMTB410CA02: '',
		// 		ORMTB410CA06: ''
		// 	}
		// 	this.CZmoney = ''
		// 	this.wayTypeValue = 'CW'
		// 	this.amountCapitalText = ''
		// },

		kpmsgClose() {
			this.fpsbpdfmsgobj = {}
			this.fpdialogImageUrl = ''
			this.cusUpdateObj = {}
			this.$refs.upload.clearFiles();
		},

		cdCusClose() {
			this.cdsUpdateObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
			this.CZmoney = ''
			this.wayTypeValue = 'CW'
			this.amountCapitalText = ''
		},


		innerVisibleClick() {
			if (this.RechargetypeValue == '') return this.$message.error('请选择充值类型')
			if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
			if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')

			if (!this.CZremark) {
				this.$message.error('请填写备注')
			} else {
				this.innerVisible = true
			}
		},




		upuserClick(row) {
			this.cusUpdateShow = true
			var str = JSON.stringify(row)
			console.log(str)
			this.cusUpdateObj = JSON.parse(str)
		},
		cduserClick(row) {
			this.cdsUpdateShow = true
			this.cdsUpdateObj.ORMTB410ID = row.ORMTB410ID
			this.cdsUpdateObj.SETTB411CA00 = row.ORMTB410ID
			this.cdsUpdateObj.SETTB411CA01 = row.ORMTB410CA00
			this.cdsUpdateObj.SETTB411CA02 = row.ORMTB410CA02
			this.cdsUpdateObj.SETTB411CA03 = '1'
		},
		xquserClick(row) {
			this.salefpxqWaterDetails = true
			this.userfpydmsg(row)

		},
		kpjlialClick(row) {
			this.saleWaterDetails = true
			this.cusUpdateObj.ORMTB410ID = row.khId
			this.queryWayTypeQuery()
		},
		fpshjlialClick(row) {
			this.cusUpdateObj = row
			console.log(this.cusUpdateObj)
			this.salefpshWaterDetails = true
			this.queryfpsheQuery(0)
			// this.userfpydmsg(row)
		},
		fpshjjjlialClick(row) {
			this.cusUpdateObj = row
			console.log(this.cusUpdateObj)
			this.salefpshjjDetails = true
			this.queryfpsheQuery(2)
		},

		cdjlialClick(row) {
			this.cdleWaterDetails = true
			this.cdsUpdateObj.ORMTB410ID = row.ORMTB410ID
			this.queryCdWayTypeQuery()
		},
		upDJSetuserClick(row) {
			this.cusUDJSetpdateShow = true
			var str = JSON.stringify(row)
			this.cusDJSetObj = JSON.parse(str)
			// console.log(this.cusDJSetObj)
		},
		cusADD() {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusInsertShow = true
		},
		kpjlQuer() {
			var url = "/set/settb410/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID

			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {


				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		userfpydmsg(data) {
			if (!data || !data.khId) {
				this.$message({ message: '客户信息不完整，无法查询详情', type: 'warning' })
				return
			}
			var url = "/set/settb425/selectDetail"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				khId: data.khId

			}
			this.axios.post(url, postData).then(res => {
				console.log(res)

				if (res.data.code == 200) {

					this.userfpyd = res.data.data
					this.userfpydData = this.splitPageData(res.data.data.res);
					console.log(this.userfpydData, 'opi')
					// this.cusUpdateObj = res.data.data
					console.log(res)

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusUpdateServe() {//保存冲抵信息

			if (!this.fpsbpdfmsgobj.xftt) {
				this.$message.error('请输入抬头')
				return;
			}
			if (!this.fpsbpdfmsgobj.xfsh) {
				this.$message.error('请输入税号')
				return;
			}
			if (!this.cusUpdateObj.SETTB410CA05) {
				this.$message.error('请输入账号')
				return;
			}
			if (!this.fpsbpdfmsgobj.kpje) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.cusUpdateObj.SETTB411CA03) {
				this.$message.error('请选择是否冲抵')
				return;
			}
			if (!this.cusUpdateObj.SETTB410CA07) {
				this.$message.error('请输入时间')
				return;
			}


			var url = "/set/settb410/insert"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB410CA00: this.cusUpdateObj.ORMTB410ID,
				SETTB410CA01: this.cusUpdateObj.ORMTB410CA00,
				SETTB410CA02: this.cusUpdateObj.ORMTB410CA02,
				SETTB410CA03: this.fpsbpdfmsgobj.xftt, //抬头
				SETTB410CA04: this.fpsbpdfmsgobj.xfsh, //税号
				SETTB410CA05: this.cusUpdateObj.SETTB410CA05,
				SETTB410CA06: this.fpsbpdfmsgobj.kpje, //开票金额
				SETTB410CA07: this.cusUpdateObj.SETTB410CA07,
				SETTB410CA08: this.kpedlxValue

			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('成功')
					this.querycusList()
					this.cusUpdateShow = false
					this.$refs.upload.clearFiles()
					this.cusUpdateObj = {
						ORMTB410ID: '',
						ORMTB410CA00: '',
						SETTB410CA01: '',
						ORMTB410CA02: '',
						SETTB410CA03: '',
						SETTB410CA04: '',
						SETTB410CA05: '',
						SETTB410CA06: '',
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cdsUpdateServe() {
			// if (!this.cdsUpdateObj.SETTB411CA03) {
			// 	this.$message.error('请选择是否冲抵')
			// 	return;
			// }
			if (!this.cdsUpdateObj.SETTB411CA04) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.cdsUpdateObj.SETTB411CA05) {
				this.$message.error('请输入时间')
				return;
			}
			console.log(this.cdsUpdateObj)
			var url = "/set/settb411/insert"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = this.cdsUpdateObj
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.$message.success('成功')
					this.querycusList()
					this.cdsUpdateShow = false
					this.cdsUpdateObj = {
						ORMTB410ID: '',
						SETTB411CA00: '',
						SETTB411CA01: '',
						SETTB411CA02: '',
						SETTB411CA04: '',
						SETTB411CA05: ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		rechargeTypeModify(row) {
			this.rechargeTypeModifyDig = true
			var str = JSON.stringify(row)
			this.rechargeTypeUpOBJ = JSON.parse(str)
		},
		ckfp(data) {

			// console.log(data)
			if (!data) {
				this.$message({
					message: '没有可查看的发票',
					type: 'error'
				});
				return;
			} else {
				window.open(data, '_blank')
			}




		},
		rechargefpshbut(row) {
			this.rechargefpsh = true
			this.fpsqobj = row
		},
		rechargefpjsbut(row) {
			console.log(row)
			var url = "/set/settb410Entity/settb410AuditAdmin";
			this.$prompt('请输入拒绝原因', '提示', {
				confirmButtonText: '拒绝',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				inputErrorMessage: '原因不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					SETTB410ID: row.SETTB410ID,
					SETTB410CA09: '2', //状态
					SETTB410CA11: value, //取消原因
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.pageList()
						this.$message({
							type: 'success',
							message: '拒绝成功!'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					loading.close();
				}).catch(() => {
					loading.close();
				})
			})
		},
		rechargeCdModify(row) {
			this.rechargeCdModifyDig = true
			var str = JSON.stringify(row)
			this.rechargeCdUpOBJ = JSON.parse(str)
		},
		disableCus(row, type) {
			var str = type == 1 ? '启用' : '禁用'
			this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = "/orm/ormtb410/updataCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: '',
					SETTB206ID: row.SETTB206ID,
					SETTB206CA02: type,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success(`${str}成功`)
						this.queryWayTypeQuery()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},
		rechargeTypeAdd() {
			this.rechargeTypeDig = true
		},
		rechargeTypeModifyClose() {
			this.rechargeTypeUpOBJ = {
				SETTB206CA01: ''
			}
		},
		querypreferentialCode() {
			var url = "/set/settb206/selectSETTB206List "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				"SETTB205ID": "02", //默认02
				"SETTB206CA00": "0202", //代码值默认0202
				"SETTB206CD01": this.userobj.ormtb400.ORMTB400CA03 //一级客户代码
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.preferentialType = res.data.data[0].SETTB206CA02
					// 	loading.close()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementQuery() {
			this.customerManagementList = []
			var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.customerManagementList = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementAddServe() {
			if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/set/settb206/insertVIP "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.customerManagementAddName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.customerManagementQuery()
					this.customerManagementAdd = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusUpdataClick(row) {
			this.customerManagemenUPObj = row
			this.customerManagementUpdate = true
		},
		customerManagementUpdateServe() {
			if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01) return this.$message
				.error('请修改名称')
			if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/set/settb206/updateVIP"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
				SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.customerManagementQuery()
					this.customerManagementUpdate = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreser() {
			if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/addCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.queryWayTypeQuery()
					this.rechargeTypeDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreserModify() {

			if (!this.rechargeTypeUpOBJ.SETTB410CA03) {
				this.$message.error('请输入抬头')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA04) {
				this.$message.error('请输入税号')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA05) {
				this.$message.error('请输入账号')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA06) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.rechargeTypeUpOBJ.SETTB410CA07) {
				this.$message.error('请输入时间')
				return;
			}

			var url = "/set/settb410/update"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB410ID: this.rechargeTypeUpOBJ.SETTB410ID,
				SETTB410CA01: this.rechargeTypeUpOBJ.SETTB410CA01,
				SETTB410CA02: this.rechargeTypeUpOBJ.SETTB410CA02,
				SETTB410CA03: this.rechargeTypeUpOBJ.SETTB410CA03,
				SETTB410CA04: this.rechargeTypeUpOBJ.SETTB410CA04,
				SETTB410CA05: this.rechargeTypeUpOBJ.SETTB410CA05,
				SETTB410CA06: this.rechargeTypeUpOBJ.SETTB410CA06,
				SETTB410CA07: this.rechargeTypeUpOBJ.SETTB410CA07,

			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.queryWayTypeQuery()
					this.rechargeTypeModifyDig = false

					this.rechargeTypeUpOBJ = {
						ORMTB410ID: '',
						ORMTB410CA00: '',
						SETTB410CA01: '',
						ORMTB410CA02: '',
						SETTB410CA03: '',
						SETTB410CA04: '',
						SETTB410CA05: '',
						SETTB410CA06: '',
					}

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},


		rechaTypefpkptj() {
			// this.handleRemove()
			if (!this.fpsbpdfmsgobj.xftt) {
				this.$message.error('请输入抬头')
				return;
			}
			if (!this.fpsbpdfmsgobj.xfsh) {
				this.$message.error('请输入税号')
				return;
			}
			if (!this.fpsbpdfmsgobj.kpje) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.fpsbpdfmsgobj.kprq) {
				this.$message.error('请输入时间')
				return;
			}

			var url = "/set/settb410Entity/settb410AuditAdmin"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			console.log(this.cusUpdateObj)
			var postData = {
				SETTB410CA17: this.fpsbpdfmsgobj.xftt,
				SETTB410ID: this.fpsqobj.SETTB410ID,
				SETTB410CA09: '1',
				SETTB410CA12: this.fpdialogImageUrl,
				SETTB410CA06: this.fpsbpdfmsgobj.kpje,
				SETTB410CA07: this.fpsbpdfmsgobj.kprq
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$refs.upload.clearFiles()
					this.$message.success('开票成功')
					if (this.salefpshjjDetails) {
						this.queryfpsheQuery(2)
					}
					if (this.salefpshWaterDetails) {
						this.queryfpsheQuery(0)
					}

					this.rechargefpsh = false
					this.cusUpdateObj = {}

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		rechCdPreserModify() {

			// if (!this.rechargeCdUpOBJ.SETTB411CA03) {
			// 	this.$message.error('请选择是否冲抵')
			// 	return;
			// }
			if (!this.rechargeCdUpOBJ.SETTB411CA04) {
				this.$message.error('请输入金额')
				return;
			}
			if (!this.rechargeCdUpOBJ.SETTB411CA05) {
				this.$message.error('请输入时间')
				return;
			}
			var url = "/set/settb411/update"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			console.log(this.rechargeCdUpOBJ)
			var postData = this.rechargeCdUpOBJ
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.queryCdWayTypeQuery()
					this.rechargeCdModifyDig = false

					this.rechargeCdUpOBJ = {
						ORMTB410ID: '',
						ORMTB410CA00: '',
						SETTB410CA01: '',
						ORMTB410CA02: '',
						// SETTB410CA03: '',
						SETTB410CA04: '',
						SETTB410CA05: '',
						SETTB410CA06: '',
						SETTB411CA08: ''
					}

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})


		},
		DetailsWaterClick(item) {
			// console.log(item)
			if (!item.ORMTB440CA00) {
				this.$message({
					message: '未查询到订单',
					type: 'error'
				});
				return
			}
			this.DetailsWater = true
			this.deductionRecordDetileQuery(item)
		},
		deductionRecordDetileQuery(row) {
			this.deductionRecordObj = ''
			this.DetailsWatersrcList = []
			this.DetailsWaterurl = ''
			var url = "/orm/ormtb440/selectDetails"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				ORMTB440ID: row.ORMTB413CA03,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordObj = res.data.data
					this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
					this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		}



	}
};
</script>

<style scoped>
.carDialogTitle {
	font-weight: bold;
	line-height: 60px;
	color: rgb(0, 163, 255);
}

.customerManagementPC {
	background-color: #f3f3f3;
}


.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
	margin-left: 0;
}

.customerManagementPC-btn {
	text-align: left;
	margin-bottom: 20px;
}

.customerManagementPC-btn i {
	margin-right: 10px;
}

.customerManagementPC-table {
	padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
	font-size: 12px;
	margin-right: 5px;
}

.public-chech-details-table {
	margin-top: 20px;
	max-height: 500px;
	overflow-y: auto;
}

.public-chech-details-table-no-text {
	line-height: 80px;
	text-align: center;
	border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
	margin-top: 20px;
	text-align: right;
}

.CustomerfillingDig-priceNumtext {
	font-weight: 500;
	font-size: 18px;
	line-height: 40px;
	padding: 20px 0 20px 10px;
	color: #333;
}

.CustomerfillingDig-priceNumtext span {
	color: rgba(175, 181, 4, 1.0);
	margin-left: 10px;
	font-size: 20px;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
	background-color: #f3f3f3;
}

.billOperationRecord-border {

	/* border-top: 2px solid rgba(205,205,205,.4); */
	border-top: none;
	box-sizing: border-box;
	margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center;
}

.customerRecharge-table {
	box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
	border-color: rgba(254, 172, 0, 1) !important;
}

.billOperationRecord-page {
	padding-right: 40px;
	text-align: right;
	margin-top: 20px;
	padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
	margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
	margin-right: 10px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
	overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
	overflow: auto !important;
}

.public_icon_width {
	width: 80px;
}

.levelmang-title {
	display: flex;
	color: #333;
	text-align: center;
	margin-bottom: 20px;

}

.levelmang-title div {
	padding: 10px 20px;
	background-color: #e3e3e3;
}

.levelmang-title .levelmang-title-active {
	background-color: #199FFF;
	color: #FFF;
}

.levelmang-table {
	border: 1px solid #e3e3e3;
}

.levelmang-table>li {
	display: flex;
}

.levelmang-table-head {
	text-align: center;
	background-color: #30A8FF;
	color: #FFF;
}

.levelmang-table-head>div {
	height: 50px;
	line-height: 50px;
	border-left: 1px solid #e3e3e3;
	box-sizing: border-box;
	overflow: hidden;
}

.levelmang-table-head>div:first-child {
	border: none;
}

.levelmang-table-CQ {
	flex: 1;
	position: relative;
	padding: 5px 10px;
}

.levelmang-table-CQ-list {
	border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-JB {
	width: 240px;
}

.levelmang-table-KJ,
.levelmang-table-ZK,
.levelmang-table-YH {
	width: 295px;
}

.levelmang-table-ZK input,
.levelmang-table-YH input {
	text-align: center;
}

.levelmang-table-li {
	text-align: center;
}

.levelmang-table-li-tab-li {

	border-bottom: 1px solid #e3e3e3;
}

.levelmang-table-li-tab-li:last-child {
	/* border: none; */
}

.levelmang-table-li-tab-li>div {
	border-left: 1px solid #e3e3e3;
	padding: 0 10px;
	box-sizing: border-box;
	height: 50px;
	line-height: 50px;
	vertical-align: top;
	overflow: hidden;
}

.levelmang-table-li-tab-li>div>input {
	width: 100px;
	border: 1px solid #e3e3e3;
	height: 35px;
	line-height: 35px;
	border-radius: 5px;
	margin-right: 10px;
}

.levelmang-table-CQ>div {
	position: absolute;
	left: 50%;
	top: 50%;
	width: 100%;
	transform: translate(-50%, -50%);
}

.levelmang-table-li-tab-li {
	display: flex;
}

.userfptj {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
	margin-bottom: 20px;
}

.billOperationRecord-table {
	padding: 30px 20px 0;
}

/* 分组列容器的样式 */
.group-column {
	border: 2px solid #8f9091 !important;
	border-right: none !important;
}

/* 分组数据单元格样式 */
.group-cell {
	border-left: 1px solid #8f9091 !important;
	border-bottom: 1px solid #8f9091 !important;
}

.el-table__row:not(:last-child) .group-cell {
	border-bottom: none !important;
}

.tableColumn_detail::before {
	background-color: transparent !important;
}

.tableColumn_detail::after {
	background-color: #8f9091 !important;
}

.invoice-quota-trigger {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 4px;
	background: #e8f3ff;
	color: #178bff;
	font-weight: 600;
	cursor: pointer;
	border-bottom: 1px dashed #178bff;
}

	.billOperationRecord {
		padding: 18px;
		background: transparent;
		color: var(--fszs-text);
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		gap: 12px 18px;
		padding: 16px 18px;
		margin-bottom: 16px;
		border: 1px solid rgba(220, 230, 242, 0.96);
		border-radius: var(--fszs-radius-lg);
		background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
		box-shadow: var(--fszs-shadow-sm);
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child .public_criteriaRange {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 12px 16px;
		margin: 0;
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child .public_oparetionBlock_Menu {
		height: auto;
		min-height: 36px;
		align-items: center;
		margin: 0;
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child .public_lbSty {
		color: var(--fszs-text-muted);
		font-weight: 500;
	}

	.billOperationRecord .statistic {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
		gap: 16px;
		margin: 0 0 16px;
	}

	.billOperationRecord .statistic-item {
		display: flex;
		align-items: center;
		gap: 10px;
		min-height: 72px;
		padding: 16px 18px;
		border: 1px solid rgba(220, 230, 242, 0.96);
		border-radius: var(--fszs-radius-lg);
		background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
		box-shadow: var(--fszs-shadow-sm);
	}

	.billOperationRecord .statistic-item span:last-child {
		color: var(--fszs-text-strong) !important;
		font-weight: 600;
	}

	.billOperationRecord-table {
		padding: 16px 16px 0;
		border: 1px solid rgba(220, 230, 242, 0.96);
		border-radius: var(--fszs-radius-lg);
		background: #ffffff;
		box-shadow: var(--fszs-shadow-sm);
		overflow: hidden;
	}

	.billOperationRecord-table .el-table {
		border-radius: 12px;
		overflow: hidden;
	}

	.billOperationRecord-table .el-table th {
		background: linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%) !important;
		color: var(--fszs-text-strong);
		font-weight: 600;
	}

	.billOperationRecord-table .el-table td,
	.billOperationRecord-table .el-table th {
		padding: 9px 0;
	}

	.billOperationRecord .customerManagementPC-table-btn {
		display: flex;
		justify-content: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.billOperationRecord .customerManagementPC-page,
	.billOperationRecord .billOperationRecord-page,
	.billOperationRecord .pulbic_pagesize {
		display: flex;
		justify-content: flex-end;
		padding: 12px 0 4px;
		margin-top: 12px;
	}

	.billOperationRecord .customerManagementPC-add-customer,
	.billOperationRecord .CustomerfillingDig-tab,
	.billOperationRecord .salesWatersStatisticsPC-saleWaterDetails {
		padding: 4px 8px 0;
	}

	.billOperationRecord .customerManagementPC-add-customer-li,
	.billOperationRecord .CustomerfillingDig-tab-li,
	.billOperationRecord .rechargeType-tab-li,
	.billOperationRecord .systemCorporateAccount-dialog-li {
		align-items: center;
		gap: 12px;
		padding: 10px 12px;
		border: 1px solid var(--fszs-border-soft);
		border-radius: 10px;
		background: #f8fbff;
	}

	.billOperationRecord .customerManagementPC-add-customer-li + .customerManagementPC-add-customer-li,
	.billOperationRecord .CustomerfillingDig-tab-li + .CustomerfillingDig-tab-li,
	.billOperationRecord .rechargeType-tab-li + .rechargeType-tab-li,
	.billOperationRecord .systemCorporateAccount-dialog-li + .systemCorporateAccount-dialog-li {
		margin-top: 12px;
	}

	.billOperationRecord .customerManagementPC-add-customer-li-name,
	.billOperationRecord .CustomerfillingDig-tab-li-text,
	.billOperationRecord .rechargeType-tab-li-text,
	.billOperationRecord .SCADL-text {
		color: var(--fszs-text-muted);
		font-weight: 500;
	}

	.billOperationRecord .customerManagementPC-add-customer-li-ipt input,
	.billOperationRecord .CustomerfillingDig-tab-li-ipt input,
	.billOperationRecord .rechargeType-tab-li-ipt input,
	.billOperationRecord .SCADL-input input,
	.billOperationRecord .SCADL-input .el-input__inner {
		height: 34px;
		line-height: 34px;
		padding: 0 10px;
		border: 1px solid var(--fszs-border);
		border-radius: 8px;
		background: #ffffff;
		color: var(--fszs-text);
		box-sizing: border-box;
	}

	.billOperationRecord .customerManagementPC-add-customer-btn,
	.billOperationRecord .CustomerfillingDig-tab-btn,
	.billOperationRecord .salesWatersStatisticsPC-saleWaterDetails-btn {
		display: flex;
		justify-content: center;
		gap: 12px;
		margin: 22px 0 6px;
	}

	.billOperationRecord .public_icon_width {
		min-width: 78px;
		height: 30px;
		padding: 0 12px;
		border-radius: 7px;
	}

	.billOperationRecord .public_icon_margin + .public_icon_margin {
		margin-left: 8px;
	}

	.levelmang-title {
		gap: 8px;
		margin-bottom: 14px;
		padding: 4px;
		border-radius: 10px;
		background: #f1f6fb;
		color: var(--fszs-text-muted);
	}

	.levelmang-title div {
		padding: 8px 18px;
		border-radius: 8px;
		background-color: transparent;
		font-weight: 500;
	}

	.levelmang-title .levelmang-title-active {
		background: linear-gradient(135deg, var(--fszs-primary), #3aa0ff);
		color: #ffffff;
		box-shadow: 0 6px 14px rgba(23, 139, 255, 0.18);
	}

	.levelmang-table {
		margin: 0;
		padding: 0;
		border: 1px solid var(--fszs-border);
		border-radius: 12px;
		background: #ffffff;
		overflow: auto;
	}

	.levelmang-table > li {
		min-width: 860px;
	}

	.levelmang-table-head {
		position: sticky;
		top: 0;
		z-index: 2;
		background: linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%);
		color: var(--fszs-text-strong);
		font-weight: 600;
	}

	.levelmang-table-head > div {
		height: 42px;
		line-height: 42px;
		border-left: 1px solid var(--fszs-border-soft);
	}

	.levelmang-table-CQ-list {
		border-bottom: 1px solid var(--fszs-border-soft);
		background: #fbfdff;
		color: var(--fszs-text-strong);
		font-weight: 600;
	}

	.levelmang-table-li {
		color: var(--fszs-text);
	}

	.levelmang-table-li-tab-li {
		border-bottom: 1px solid var(--fszs-border-soft);
	}

	.levelmang-table-li-tab-li > div {
		height: 46px;
		line-height: 46px;
		border-left: 1px solid var(--fszs-border-soft);
	}

	.levelmang-table-li-tab-li > div > input,
	.levelmang-table-ZK input,
	.levelmang-table-YH input {
		width: 96px;
		height: 32px;
		line-height: 32px;
		padding: 0 8px;
		border: 1px solid var(--fszs-border);
		border-radius: 8px;
		background: #ffffff;
		color: var(--fszs-text);
		box-sizing: border-box;
		transition: var(--fszs-transition);
	}

	.levelmang-table-li-tab-li > div > input:focus,
	.levelmang-table-ZK input:focus,
	.levelmang-table-YH input:focus {
		border-color: var(--fszs-primary);
		box-shadow: var(--fszs-focus);
		outline: none;
	}

	.billOperationRecord .statistic,
	.billOperationRecord .customerManagementPC-page,
	.billOperationRecord .billOperationRecord-page,
	.billOperationRecord .pulbic_pagesize,
	.billOperationRecord .systemCorporateAccount-dialog-btn,
	.billOperationRecord .salesPreferentialDig-btn {
		flex-wrap: wrap;
	}

	@media screen and (max-width: 1366px) {
		.billOperationRecord {
			padding: 14px;
		}

		.billOperationRecord > .pulbic_oparetionBlock:first-child {
			padding: 14px;
		}

		.billOperationRecord .customerManagementPC-table-btn {
			justify-content: flex-start;
		}

		.levelmang-table-KJ,
		.levelmang-table-ZK,
		.levelmang-table-YH {
			width: 180px;
		}
	}

.sale-customer-invoice-page {
	position: relative;
	min-height: 100%;
	box-sizing: border-box;
	padding: 16px;
	background:
		radial-gradient(circle at 86% 6%, rgba(34, 126, 214, .14), transparent 28%),
		radial-gradient(circle at 5% 30%, rgba(233, 166, 83, .12), transparent 24%),
		linear-gradient(180deg, #edf5fb 0%, #f8fbfd 48%, #f9fbfc 100%);
	--customer-primary: #227ed6;
	--customer-accent: #eaa65d;
	--customer-green: #22a879;
	--customer-text: #22384d;
	--customer-muted: #708399;
	--customer-border: #d9e6f2;
	--customer-shadow: 0 14px 34px rgba(34, 58, 84, .1);
	font-family: "Microsoft YaHei", sans-serif;
}

.sale-customer-invoice-page .customerManagementPC {
	padding: 0;
	background: transparent;
}

.sale-customer-invoice-page .sale-customer-filter-panel,
.sale-customer-invoice-page .sale-customer-table-card,
.sale-customer-invoice-page .sale-customer-statistic .statistic-item {
	box-sizing: border-box;
	border: 1px solid rgba(217, 230, 242, .95);
	border-radius: 18px;
	background: rgba(255, 255, 255, .96);
	box-shadow: var(--customer-shadow);
}

.sale-customer-invoice-page .sale-customer-filter-panel {
	padding: 18px 20px;
	margin-bottom: 14px;
}

.sale-customer-filter-head,
.sale-customer-table-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.sale-customer-filter-title,
.sale-customer-table-title {
	position: relative;
	padding-left: 12px;
	color: var(--customer-text);
	font-size: 18px;
	font-weight: 800;
	line-height: 1.35;
}

.sale-customer-filter-title::before,
.sale-customer-table-title::before {
	content: "";
	position: absolute;
	left: 0;
	top: 4px;
	width: 4px;
	height: 18px;
	border-radius: 8px;
	background: linear-gradient(180deg, var(--customer-primary), var(--customer-accent));
}

.sale-customer-filter-subtitle,
.sale-customer-table-subtitle {
	margin-top: 6px;
	color: var(--customer-muted);
	font-size: 13px;
}

.sale-customer-filter-count,
.sale-customer-table-tag {
	flex: 0 0 auto;
	padding: 8px 14px;
	border: 1px solid rgba(34, 126, 214, .14);
	border-radius: 999px;
	background: linear-gradient(135deg, rgba(34, 126, 214, .1), rgba(234, 166, 93, .12));
	color: #1c63ad;
	font-size: 13px;
	font-weight: 700;
}

.sale-customer-invoice-page .sale-customer-filter-controls {
	display: flex;
	flex-wrap: wrap;
	align-items: center !important;
	gap: 12px 14px;
	margin: 18px 0 0;
	padding: 14px;
	border: 1px solid rgba(217, 230, 242, .82);
	border-radius: 14px;
	background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);
}

.sale-customer-invoice-page .sale-customer-filter-item {
	display: flex;
	align-items: center;
	gap: 10px;
	height: auto;
	margin: 0;
}

.sale-customer-invoice-page .sale-customer-filter-item .public_lbSty {
	width: auto;
	min-width: 72px;
	color: var(--customer-text);
	font-weight: 700;
}

.sale-customer-invoice-page >>> .sale-customer-filter-item .public_optionSty,
.sale-customer-invoice-page >>> .sale-customer-filter-item .el-input,
.sale-customer-invoice-page >>> .sale-customer-filter-item .el-select {
	width: 220px !important;
}

.sale-customer-invoice-page >>> .sale-customer-filter-item .el-input__inner {
	height: 40px;
	line-height: 40px;
	border: 1px solid var(--customer-border);
	border-radius: 10px;
	color: var(--customer-text);
}

.sale-customer-invoice-page >>> .sale-customer-filter-item .el-input__inner:focus {
	border-color: var(--customer-primary);
	box-shadow: 0 0 0 3px rgba(34, 126, 214, .13);
}

.sale-customer-invoice-page .sale-customer-query-btn {
	height: 40px;
	min-width: 96px;
	margin-left: 0 !important;
	padding: 0 20px;
	border: none;
	border-radius: 10px;
	background: linear-gradient(135deg, var(--customer-primary), #35a1f4) !important;
	box-shadow: 0 9px 18px rgba(34, 126, 214, .22);
	font-weight: 700;
}

.sale-customer-invoice-page .customerManagementPC-btn {
	display: none;
}

.sale-customer-invoice-page .sale-customer-statistic {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 14px;
	margin: 0 0 14px;
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-item {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
	min-height: 78px;
	min-width: 200px;
	padding: 18px 20px;
	transition: all .18s ease;
	white-space: nowrap;
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-item:hover {
	transform: translateY(-2px);
	box-shadow: 0 18px 38px rgba(34, 58, 84, .14);
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-item i {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 42px;
	height: 42px;
	border-radius: 14px;
	background: rgba(234, 166, 93, .12);
	font-size: 22px;
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-item:nth-child(2) i {
	background: rgba(34, 168, 121, .12);
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-item span:last-child {
	font-size: 20px;
	font-weight: 800;
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-label {
	font-size: 15px !important;
	font-weight: 600;
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-value {
	font-size: 20px !important;
	font-weight: 800;
}

.sale-customer-invoice-page .sale-customer-statistic .statistic-item-head {
	display: flex;
	align-items: center;
	gap: 8px;
}

.sale-customer-invoice-page .sale-customer-table-card {
	padding: 18px 18px 0;
	overflow: hidden;
}

.sale-customer-invoice-page .sale-customer-table-head {
	margin-bottom: 16px;
	padding-bottom: 14px;
	border-bottom: 1px solid rgba(217, 230, 242, .76);
}

.sale-customer-invoice-page >>> .sale-customer-main-table {
	border-radius: 14px;
	overflow: hidden;
}

.sale-customer-invoice-page >>> .sale-customer-main-table::before {
	display: none;
}

.sale-customer-invoice-page >>> .sale-customer-main-table th {
	background: linear-gradient(180deg, #f4f9ff 0%, #eaf4ff 100%) !important;
}

.sale-customer-invoice-page >>> .sale-customer-main-table th .cell {
	color: #24384b;
	font-size: 14px;
	font-weight: 800;
	white-space: nowrap;
}

.sale-customer-invoice-page >>> .sale-customer-main-table td {
	padding: 10px 0;
	border-bottom: 1px solid rgba(225, 234, 244, .86);
}

.sale-customer-invoice-page >>> .sale-customer-main-table .el-table__row:hover > td {
	background: #f4f9ff !important;
}

.sale-customer-invoice-page >>> .sale-customer-main-table .customerManagementPC-table-btn {
	display: flex;
	justify-content: center;
	gap: 8px;
	flex-wrap: wrap;
}

.sale-customer-invoice-page >>> .sale-customer-main-table .public_icon_width {
	min-width: 78px;
	height: 32px;
	padding: 0 12px;
	border: none;
	border-radius: 999px;
	font-weight: 700;
}

.sale-customer-invoice-page >>> .sale-customer-main-table .public_icon_xiangqing {
	background: linear-gradient(135deg, var(--customer-primary), #35a1f4) !important;
	color: #ffffff !important;
}

.sale-customer-invoice-page .customerManagementPC-page,
.sale-customer-invoice-page .billOperationRecord-page {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	padding: 14px 0 4px;
	margin-top: 10px;
	text-align: right;
}

.sale-customer-invoice-page >>> .public-dialog .el-dialog {
	border-radius: 18px;
	overflow: hidden;
	box-shadow: 0 18px 46px rgba(28, 49, 75, .18);
}

.sale-customer-invoice-page >>> .public-dialog .el-dialog__header {
	padding: 18px 22px;
	background: linear-gradient(135deg, #eff7ff 0%, #f7fbff 100%);
	border-bottom: 1px solid rgba(217, 230, 242, .9);
}

.sale-customer-invoice-page >>> .public-dialog .el-dialog__title {
	color: var(--customer-text);
	font-size: 18px;
	font-weight: 800;
}

.sale-customer-invoice-page >>> .public-dialog .el-dialog__body {
	padding: 20px 22px 22px;
}

.sale-customer-invoice-page .customerManagementPC-add-customer-li,
.sale-customer-invoice-page .rechargeType-tab-li {
	align-items: center;
	gap: 12px;
	padding: 10px 12px;
	border: 1px solid rgba(217, 230, 242, .92);
	border-radius: 12px;
	background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);
}

.sale-customer-invoice-page .customerManagementPC-add-customer-li + .customerManagementPC-add-customer-li,
.sale-customer-invoice-page .rechargeType-tab-li + .rechargeType-tab-li {
	margin-top: 12px;
}

.sale-customer-invoice-page .customerManagementPC-add-customer-li-name,
.sale-customer-invoice-page .rechargeType-tab-li-text {
	color: var(--customer-muted);
	font-weight: 700;
}

.sale-customer-invoice-page .customerManagementPC-add-customer-li-ipt input,
.sale-customer-invoice-page .rechargeType-tab-li-ipt input {
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	border: 1px solid var(--customer-border);
	border-radius: 9px;
	color: var(--customer-text);
	box-sizing: border-box;
}

.sale-customer-invoice-page >>> .el-upload-dragger {
	border-radius: 16px;
	background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);
}

@media screen and (max-width: 1366px) {
	.sale-customer-invoice-page {
		padding: 12px;
	}

	.sale-customer-invoice-page .sale-customer-filter-panel,
	.sale-customer-invoice-page .sale-customer-table-card,
	.sale-customer-invoice-page .sale-customer-statistic .statistic-item {
		border-radius: 14px;
	}
}

@media screen and (max-width: 768px) {
	.sale-customer-filter-head,
	.sale-customer-table-head {
		align-items: flex-start;
		flex-direction: column;
	}

	.sale-customer-invoice-page .sale-customer-statistic {
		grid-template-columns: 1fr;
	}

	.sale-customer-invoice-page .sale-customer-filter-item,
	.sale-customer-invoice-page >>> .sale-customer-filter-item .public_optionSty,
	.sale-customer-invoice-page >>> .sale-customer-filter-item .el-input,
	.sale-customer-invoice-page >>> .sale-customer-filter-item .el-select,
	.sale-customer-invoice-page .sale-customer-query-btn {
		width: 100% !important;
	}
}
</style>
<style>
.sales-sale-customer-invoice-dialog {
	border: 1px solid rgba(207, 225, 245, 0.95);
	border-radius: 18px;
	background: #f8fbff;
	box-shadow: 0 24px 70px rgba(18, 52, 77, 0.22);
	overflow: hidden;
}

.sales-sale-customer-invoice-dialog .el-dialog__header {
	position: relative;
	height: auto;
	line-height: normal;
	padding: 18px 54px 16px 24px;
	vertical-align: middle;
	background: linear-gradient(135deg, #f5fbff 0%, #ffffff 48%, #eef8ff 100%);
	border-bottom: 1px solid rgba(219, 233, 247, 0.95);
	color: #17324d;
}

.sales-sale-customer-invoice-dialog .el-dialog__header::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 5px;
	height: 100%;
	background: linear-gradient(180deg, #199fff 0%, #5ac8fa 100%);
}

.sales-sale-customer-invoice-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #17324d !important;
	letter-spacing: .2px;
}

.sales-sale-customer-invoice-dialog .el-dialog__headerbtn {
	top: 13px;
	right: 18px;
	border-radius: 50%;
	background: rgba(25, 159, 255, 0.08);
	transition: background .2s ease, transform .2s ease;
}

.sales-sale-customer-invoice-dialog .el-dialog__headerbtn:hover {
	background: rgba(25, 159, 255, 0.16);
	transform: rotate(90deg);
}

.sales-sale-customer-invoice-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}

.sales-sale-customer-invoice-dialog .el-dialog__body {
	max-height: calc(90vh - 130px);
	padding: 22px 24px 24px;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
	color: #31445a;
	overflow-y: auto;
}

.sales-sale-customer-invoice-dialog .el-table td .cell,
.sales-sale-customer-invoice-dialog .el-table th .cell {
	text-align: center;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab,
.sales-sale-customer-invoice-dialog .salesWatersStatisticsPC-saleWaterDetails {
	padding: 0;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li {
	display: grid;
	grid-template-columns: 120px minmax(0, 1fr) 64px;
	align-items: center;
	gap: 10px;
	min-height: 46px;
	padding: 10px 12px;
	border: 1px solid rgba(220, 232, 245, 0.9);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.88);
	box-shadow: 0 6px 16px rgba(23, 77, 124, 0.05);
	box-sizing: border-box;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li + .customerManagementPC-add-customer-li,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li + .CustomerfillingDig-tab-li,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li + .rechargeType-tab-li {
	margin-top: 12px;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-name,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-text,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-text {
	color: #203a56;
	font-size: 14px;
	font-weight: 600;
	text-align: right;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-ipt,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-ipt,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-ipt {
	min-width: 0;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-ipt input,
.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-ipt .el-input__inner,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-ipt input,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-ipt .el-input__inner,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-ipt input,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-ipt .el-input__inner {
	width: 100%;
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	border: 1px solid #d7e5f3;
	border-radius: 9px;
	background: #fff;
	color: #1f3449;
	box-sizing: border-box;
	transition: border-color .18s ease, box-shadow .18s ease;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-ipt input:focus,
.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-ipt .el-input__inner:focus,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-ipt input:focus,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-ipt .el-input__inner:focus,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-ipt input:focus,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-ipt .el-input__inner:focus {
	border-color: #199fff;
	box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
	outline: none;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-ipt input:disabled,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-ipt input:disabled,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-ipt input:disabled {
	background: #f3f7fb;
	color: #7a8ca0;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-type,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-b,
.sales-sale-customer-invoice-dialog .rechargeType-tab-li-b {
	color: #ff6b6b;
	font-size: 12px;
	white-space: nowrap;
}

.sales-sale-customer-invoice-dialog .el-select,
.sales-sale-customer-invoice-dialog .el-date-editor.el-input,
.sales-sale-customer-invoice-dialog .el-date-editor.el-input__inner {
	width: 100%;
}

.sales-sale-customer-invoice-dialog .el-radio {
	margin-right: 18px;
	line-height: 28px;
	color: #31445a;
}

.sales-sale-customer-invoice-dialog .el-upload,
.sales-sale-customer-invoice-dialog .el-upload-dragger {
	width: 100%;
}

.sales-sale-customer-invoice-dialog .el-upload-dragger {
	border: 1px dashed #9dc8ee;
	border-radius: 16px;
	background: linear-gradient(180deg, #fbfdff 0%, #f2f8ff 100%);
	transition: border-color .2s ease, box-shadow .2s ease;
}

.sales-sale-customer-invoice-dialog .el-upload-dragger:hover {
	border-color: #199fff;
	box-shadow: 0 10px 26px rgba(25, 159, 255, 0.12);
}

.sales-sale-customer-invoice-dialog .el-upload__tip {
	margin-top: 10px;
	padding: 8px 12px;
	border-radius: 10px;
	background: rgba(255, 107, 107, 0.08);
	line-height: 1.5;
}

.sales-sale-customer-invoice-dialog .el-table {
	border-radius: 12px;
	overflow: hidden;
}

.sales-sale-customer-invoice-dialog .el-table::before {
	display: none;
}

.sales-sale-customer-invoice-dialog .el-table th {
	background: linear-gradient(180deg, #f4f9ff 0%, #eaf4ff 100%) !important;
}

.sales-sale-customer-invoice-dialog .el-table th .cell {
	color: #24384b;
	font-weight: 700;
}

.sales-sale-customer-invoice-dialog .el-table td {
	border-bottom: 1px solid rgba(225, 234, 244, .86);
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-btn,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-btn,
.sales-sale-customer-invoice-dialog .salesWatersStatisticsPC-saleWaterDetails-btn {
	display: flex;
	justify-content: space-between;
	gap: 16px;
	margin: 22px 0 0;
	padding-top: 18px;
	border-top: 1px solid rgba(223, 235, 247, 0.9);
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-btn .el-button,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-btn .el-button,
.sales-sale-customer-invoice-dialog .salesWatersStatisticsPC-saleWaterDetails-btn .el-button {
	min-width: 96px;
	border-radius: 9px;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-btn .el-button--info,
.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-btn .el-button--warning,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-btn .el-button--info,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-btn .el-button--warning,
.sales-sale-customer-invoice-dialog .salesWatersStatisticsPC-saleWaterDetails-btn .el-button--info,
.sales-sale-customer-invoice-dialog .salesWatersStatisticsPC-saleWaterDetails-btn .el-button--warning {
	order: 1;
	margin-left: 0;
}

.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-btn .el-button--primary,
.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-btn .el-button--primary,
.sales-sale-customer-invoice-dialog .salesWatersStatisticsPC-saleWaterDetails-btn .el-button--primary {
	order: 2;
	margin-left: 0;
}

.sales-sale-customer-invoice-dialog .billOperationRecord-page,
.sales-sale-customer-invoice-dialog .customerManagementPC-page,
.sales-sale-customer-invoice-dialog .pulbic_pagesize {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	padding: 14px 0 0;
	margin-top: 10px;
}

.sales-sale-customer-invoice-dialog .public_icon_width {
	min-width: 78px;
	height: 32px;
	padding: 0 12px;
	border-radius: 8px;
	font-weight: 700;
}

@media screen and (max-width: 768px) {
	.sales-sale-customer-invoice-dialog {
		width: calc(100vw - 24px) !important;
	}

	.sales-sale-customer-invoice-dialog .el-dialog__body {
		padding: 18px 16px 20px;
	}

	.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li,
	.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li,
	.sales-sale-customer-invoice-dialog .rechargeType-tab-li {
		grid-template-columns: 1fr;
		gap: 8px;
	}

	.sales-sale-customer-invoice-dialog .customerManagementPC-add-customer-li-name,
	.sales-sale-customer-invoice-dialog .CustomerfillingDig-tab-li-text,
	.sales-sale-customer-invoice-dialog .rechargeType-tab-li-text {
		text-align: left;
	}
}
</style>
